const breakpoints = {
  'tiny': {
    min: 0,
    max: 374,
  },
  'xs': {
    min: 0,
    max: 480,
  },
  'sm': {
    min: 481,
    max: 767,
  },
  'md': {
    min: 768,
    max: 991,
  },
  'lg': {
    min: 992,
    max: 1199,
  },
  'xl': {
    min: 1200,
    max: 1599,
  },
  'max': {
    min: 1600,
    max: Infinity,
  }
}

const bp = (breakpoint, type = 'min') => breakpoints[breakpoint][type]

export { 
  breakpoints
}
